var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import config from '@/config';
import api from '@/shared/api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var useGetPlannedTasks = function (filters, pageParams) {
    var _a;
    var intl = useIntl();
    var cacheKey = [TaskQueryKey.PlannedTasks];
    var _b = useInfiniteQuery(cacheKey, function (_a) {
        var signal = _a.signal, pageParam = _a.pageParam;
        return api.base
            .get("".concat(config.appUrls.tasks, "/api/plannedTasks"), {
            params: __assign(__assign(__assign({}, filters), pageParams), { page: pageParam }),
            signal: signal,
        })
            .then(function (res) { return res.data; });
    }, {
        enabled: true,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        getNextPageParam: function (lastPage, allPages) {
            return lastPage.length === pageParams.take ? allPages.length : undefined;
        },
        notifyOnChangeProps: 'all',
    }), data = _b.data, isLoading = _b.isLoading, error = _b.error, refetch = _b.refetch, fetchNextPage = _b.fetchNextPage;
    return {
        data: (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a.flat(1),
        error: error,
        isLoading: isLoading,
        refetch: refetch,
        fetchNextPage: fetchNextPage,
    };
};
